import { Component, OnInit } from '@angular/core';
import { EditFormBase } from '../../core/helper/editFormBase';
import { TramosCodigoEmpleado } from '../../core/models/tramosCodigoEmpleado.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { Location } from '@angular/common';
import { TramosCodigoEmpleadosService } from '../../core/services/tramosCodigoEmpleados.service';
import { ErrorApi } from '../../core/models/errorApi.model';
import { TramosCodigoEmpleadoRequest } from '../../core/models/tramosCodigoEmpleadoRequest.model';

@Component({
  selector: 'app-tramos-codigo-empleados',
  templateUrl: './tramos-codigo-empleados.component.html',
  styleUrls: ['./tramos-codigo-empleados.component.scss'],
  providers: [TramosCodigoEmpleadosService]
})
export class TramosCodigoEmpleadosComponent extends EditFormBase<TramosCodigoEmpleado, string> implements OnInit {

  panelIcon = 'sliders-h'; // Awesome icon
  panelTitle = 'Tramos Código Empleado';
  panelDescription = '';

  selectedCompany: string;
  trabajadorCodInicial: number;
  trabajadorCodFinal: number;
  profesionalCodInicial: number;
  profesionalCodFinal: number;

  constructor(
    _route: ActivatedRoute,
    protected _modelService: TramosCodigoEmpleadosService,
    _messageDialog: MessageDialog,
    protected _session: SessionHelper,
    _router: Router,
    _location: Location,
  ) {
    super(_modelService, _messageDialog, _route, _router, _location, TramosCodigoEmpleado);
  }

  ngOnInit(): void {
  }

  onSubmit(form: TramosCodigoEmpleado) {
    if(this.comprobarTramos()) {
      return;
    }
    
    const tramos: TramosCodigoEmpleadoRequest = {
      trabajadorCodInicial: this.trabajadorCodInicial,
      trabajadorCodFinal: this.trabajadorCodFinal,
      profesionalCodInicial: this.profesionalCodInicial,
      profesionalCodFinal: this.profesionalCodFinal,
    };
    
    this._modelService.guardarTramosCodigo(this.selectedCompany, tramos).subscribe((response) => {
      this._messageDialog.ShowMessage(
        'Tramos de códigos de empleados actualizados correctamente',
        'Actualizado'
      )
    }, error => {
      console.error(error);
      this._messageDialog.ShowException(error.error_description);      
    });
  }

  comprobarTramos(): boolean {
    let errorMsg = '';

    if(this.trabajadorCodInicial > this.trabajadorCodFinal) {
      errorMsg = 'Los tramos de tipo de empleado Trabajador no son válidos.';
    }
    else if(this.trabajadorCodFinal >= this.profesionalCodInicial) {
      errorMsg = 'El código final del tipo de empleado Trabajador es mayor que el código inicial de Profesional.';
    }
    /*else if(this.comiteCodInicial > this.comiteCodFinal) {
      errorMsg = 'Los tramos de tipo de empleado Trabajador Comité no son válidos.';
    }
    else if(this.comiteCodFinal >= this.profesionalCodInicial) {
      errorMsg = 'El código final del tipo de empleado Trabajador Comité es mayor que el código inicial de Profesional.';
    }
    else if(this.profesionalCodInicial < 900000) {
      errorMsg = 'El código inicial del tipo de empleado Profesional no puede ser menor a 900000.';
    } */
    else if (this.profesionalCodFinal !== 0 && this.profesionalCodFinal < this.profesionalCodInicial) {
      errorMsg = 'Los tramos de tipo de empleado Profesional no son válidos.';
    }

    if(errorMsg) {
      const errorApi: ErrorApi = {
        Error: errorMsg,
        ErrorDescription: [errorMsg]
      };
      this._messageDialog.ShowException(errorApi);
      return true;
    }

    return false;
  }

  onCompanyChange(selectedCompany: number): void {
    if(selectedCompany) {
      this._modelService.obtenerTramosCodigo(selectedCompany).subscribe((response) => {
        console.log('Response from server:', response);
        if (response) {
          const tramos = response[0];
          if(tramos) {
            this.trabajadorCodInicial = tramos.TrabajadorCodInicial;
            this.trabajadorCodFinal = tramos.TrabajadorCodFinal;
            this.profesionalCodInicial = tramos.ProfesionalCodInicial;
            this.profesionalCodFinal = tramos.ProfesionalCodFinal;
          } else {
            this.trabajadorCodInicial = null;
            this.trabajadorCodFinal = null;
            this.profesionalCodInicial = null;
            this.profesionalCodFinal = null;
          }
        }
      }, error => {
        console.error(error);
      });
    }
  }

  afterModelLoad(): void {
    throw new Error('Method not implemented.');
  }
  afterModelUpdated(success: boolean): void {
    throw new Error('Method not implemented.');
  }
  afterModelCreated(success: boolean): void {
    throw new Error('Method not implemented.');
  }
  getModelInstance(): TramosCodigoEmpleado {
    throw new Error('Method not implemented.');
  }
}
